module.exports = __webpack_public_path__ + "img/怡脂.073ee66.png";